export default "/50f517735fec46580f19aae3e56e9fe21614ea75/837e258702481769ad64684ae735d0c9.svg";